import React from 'react';
import {
    Card,
    FormLayout,
    Checkbox,
    Button,
    TextField
} from '@shopify/polaris';
import { StringValueEntry } from '../StringValueEntry';

export function TagCustomersByPurchasedProductsSettings(props) {

    function handlePrefixDelete(index) {

        const newPrefixes = [
            ...props.settings.tagByPurchasedProductTags.tagPrefixes.slice(0, index),
            ...props.settings.tagByPurchasedProductTags.tagPrefixes.slice(index + 1),
        ];

        var newTagByPurchasedProductTags = { ...props.settings.tagByPurchasedProductTags };
        newTagByPurchasedProductTags.tagPrefixes = newPrefixes;

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.tagByPurchasedProductTags = newTagByPurchasedProductTags;
        props.onSettingsChange(newSettings);
    }

    function handlePrefixValueUpdate(index, value) {

        const newPrefixes = [
            ...props.settings.tagByPurchasedProductTags.tagPrefixes.slice(0, index),
            value,
            ...props.settings.tagByPurchasedProductTags.tagPrefixes.slice(index + 1),
        ]

        var newTagByPurchasedProductTags = { ...props.settings.tagByPurchasedProductTags };
        newTagByPurchasedProductTags.tagPrefixes = newPrefixes;

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.tagByPurchasedProductTags = newTagByPurchasedProductTags;
        props.onSettingsChange(newSettings);
    }

    const toggleTagByPurchasedProductTags = (newValue) => {

        var newSettings = JSON.parse(JSON.stringify(props.settings));

        if (newValue) {

            newSettings.tagByPurchasedProductTags = {
                useAllTags: false,
                tagPrefixes: []
            };
        }
        else {
            newSettings.tagByPurchasedProductTags = null;
        }

        props.onSettingsChange(newSettings);
    }

    const toggleTagByProductIds = (newValue) => {

        var newSettings = JSON.parse(JSON.stringify(props.settings));

        if (newValue) {
            newSettings.tagByPurchasedProductId =
            {
                tagPrefix: ""
            };
        }
        else {
            newSettings.tagByPurchasedProductId = null;
        }

        props.onSettingsChange(newSettings);
    }

    function toggleUseAllTags(newValue) {

        var newTagByPurchasedProductTags = { ...props.settings.tagByPurchasedProductTags };
        newTagByPurchasedProductTags.useAllTags = newValue;

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.tagByPurchasedProductTags = newTagByPurchasedProductTags;
        props.onSettingsChange(newSettings);
    }

    function handleAddNewPrefix() {

        const newPrefixes = [
            ...props.settings.tagByPurchasedProductTags.tagPrefixes,
            "provide_prefix_name_"];

        var newTagByPurchasedProductTags = { ...props.settings.tagByPurchasedProductTags };
        newTagByPurchasedProductTags.tagPrefixes = newPrefixes;

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.tagByPurchasedProductTags = newTagByPurchasedProductTags;
        props.onSettingsChange(newSettings);
    }

    function handleTagPrefixChange(value) {

        var newTagByPurchasedProductId = { ...props.settings.tagByPurchasedProductId };
        newTagByPurchasedProductId.tagPrefix = value;

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.tagByPurchasedProductId = newTagByPurchasedProductId;
        props.onSettingsChange(newSettings);
    }

    var prefixElements = null;

    if (props.settings.tagByPurchasedProductTags != null) {
        prefixElements = props.settings.tagByPurchasedProductTags.tagPrefixes.map((item, index) => {
            return <StringValueEntry
                key={index}
                index={index}
                value={item}
                placeholderText={"Enter tag name or tag prefix"}
                onDelete={handlePrefixDelete}
                onUpdate={handlePrefixValueUpdate}
            />
        });
    }

    return (
        <React.Fragment>
            <Card.Section title="Tag By Product Tags">
                <Checkbox
                    label="Enable Tag By Product Tags"
                    checked={props.settings.tagByPurchasedProductTags != null}
                    onChange={toggleTagByPurchasedProductTags}
                    helpText={
                        <span>
                            When checked, customers will be tagged with tags belonging to the products that were purchased.
                        </span>
                    }
                />
                <br />
                {props.settings.tagByPurchasedProductTags != null &&
                    <FormLayout>
                        <Checkbox
                            label="Add All Product Tags"
                            checked={props.settings.tagByPurchasedProductTags.useAllTags}
                            onChange={toggleUseAllTags}
                            helpText={
                                <span>
                                    When checked, all tags belonging to a purchased product will be added to the respective customer.
                                    Alternatively, you can include specific tags by specifying a full tag name or a tag prefix.
                                </span>
                            }
                        />
                        <div>
                            {prefixElements}
                            <Button plain onClick={handleAddNewPrefix}>Include Tag Prefix</Button>
                        </div>
                    </FormLayout>
                }
            </Card.Section>
            <Card.Section title="Tag By Product Ids">
                <Checkbox
                    label="Enable Tag By Product Ids"
                    checked={props.settings.tagByPurchasedProductId != null}
                    onChange={toggleTagByProductIds}
                    helpText={
                        <span>
                            When checked, customers will be tagged with the ids of the products that were purchased.
                        </span>
                    }
                />
                <br />
                {props.settings.tagByPurchasedProductId != null &&
                    <FormLayout>
                        <TextField
                            label="Tag prefix (optional)"
                            placeholder="Tag prefix"
                            helpText={
                                <span>
                                    Add a prefix to the product id so that you can more easily identify product id tag
                                </span>
                            }
                            value={props.settings.tagByPurchasedProductId.tagPrefix}
                            onChange={handleTagPrefixChange}
                            autoComplete="off"
                        />
                    </FormLayout>
                }
            </Card.Section>
        </React.Fragment>
    );
}